import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { CleanupPage } from 'pages/contacts/pages/cleanup/ui/cleanupPage'
import { CleanupLayout } from 'pages/contacts/pages/cleanup/layout/CleanupLayout'

export const CleanupRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<CleanupLayout />}>
        <Route path={'/'} element={<CleanupPage />} />
      </Route>
    </RoutesWithNotFound>
  )
}
